// DXD-7359: date filters send plain calendar dates; the backend cuts the day
// at India midnight (admin BE utils/istDateRange.js). Nothing here builds a
// Date from a user-picked value, so the browser's timezone never matters.

export const IST_ZONE = 'Asia/Kolkata';

export type PlainDateRange = { fromDate?: string; toDate?: string };

/** The In-Field Stats filter as applied: dates plus the Status choice ('All' omitted). */
export type InFieldFilter = PlainDateRange & { status?: string };

/** Grid state -> the filter the grid and the partner export both send. */
export function inFieldFilter(fromDate?: string | null, toDate?: string | null, status?: string | null): InFieldFilter {
    const filter: InFieldFilter = plainDateRange(fromDate, toDate);
    const s = (status || '').trim();
    if (s && s !== 'All') filter.status = s;
    return filter;
}

/** <input type="date"> values ('YYYY-MM-DD') passed through as-is; blanks are omitted. */
export function plainDateRange(fromDate?: string | null, toDate?: string | null): PlainDateRange {
    const range: PlainDateRange = {};
    const f = (fromDate || '').trim();
    const t = (toDate || '').trim();
    if (f) range.fromDate = f;
    if (t) range.toDate = t;
    return range;
}

/** Today's calendar date in India, 'YYYY-MM-DD', whatever the browser's timezone. */
export function todayInIST(now: Date = new Date()): string {
    // en-CA formats as YYYY-MM-DD.
    return new Intl.DateTimeFormat('en-CA', {
        timeZone: IST_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
    }).format(now);
}

/** Filename fragment describing the range, e.g. '_2026-10-27_to_2026-10-28'; '' when open. */
export function rangeFileSuffix(range: PlainDateRange): string {
    if (range.fromDate && range.toDate) return `_${range.fromDate}_to_${range.toDate}`;
    if (range.fromDate) return `_from_${range.fromDate}`;
    if (range.toDate) return `_to_${range.toDate}`;
    return '';
}

/** Filename fragment for the whole filter: range plus status label, e.g. '_2026-10-28_to_2026-10-28_Live'. */
export function filterFileSuffix(filter: InFieldFilter, statusLabel?: (v: string) => string): string {
    const status = filter.status ? `_${(statusLabel ? statusLabel(filter.status) : filter.status).replace(/[^a-zA-Z0-9]+/g, '')}` : '';
    return rangeFileSuffix(filter) + status;
}
